import React, { useState } from "react";
import SingleSelectWithSearch from "../../../components/dropdown/SingleSelectWithSearch";
import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";

export const rowData = [];
export const colDefs = [];

export const table2Data = [];
export const table2ColDefs = [];

export const AddCashAdvancePopUp = (props) => {
    return (
        <ModalBasic
            id="voucher-receipt-details"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className="input-fields bg-white p-[30px] shadow-normalShadow rounded-[10px]">
                <div className="item-grp">
                    <span className="text-blue text-[16px] font-semibold">Receipt details</span>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mt-[12px] pb-[10px] border-b border-slate-200 lightBlue">
                        <div className="input-outer-grp flex gap-2.5">
                            <div className="input-grp w-[40%]">
                                <label>Receipt no</label>
                                <TextInput
                                    type="number"
                                    id="receiptNo"
                                    name="receiptNo"
                                    value={props.receiptDetails.receiptNo}
                                    handleChange={(event) => props.handleChange(event, "receiptNo")}
                                    disabled />
                            </div>

                            <div className="input-grp w-[60%]">
                                <label>Date</label>
                                <TextInput
                                    type="date"
                                    id="date"
                                    name="date"
                                    value={props.receiptDetails.date}
                                    handleChange={(event) => props.handleChange(event, "date")} c
                                    className={props.validState?.error?.date !== undefined ? "error" : ""} />
                            </div>
                        </div>
                        <div className="input-grp">
                            <label>Select employee</label>
                            <SingleSelectWithSearch
                                drpIdentity={"employeeList"}
                                optionArray={props.receiptDetails.employeeList}
                                value={props.receiptDetails.idEmployee}
                                handleChangeTest={props.handleSelectChange}
                                searchText={props.receiptDetails.employeeName}
                                classParams={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                                setFilterParameters={props.setFilterParameters}
                            />
                            {/* <SingleSelectWithSearch
                                id="selectEmployee"
                                name="selectEmployee"
                                value={props.receiptDetails.selectEmployee}
                                handleChangeTest={(event) => props.handleSelectChange(event, "selectEmployee")}
                                className={props.validState?.error?.selectEmployee !== undefined ? "error" : ""} /> */}
                        </div>

                        <div className="input-grp">
                            <label>Acc. Sub Head</label>
                            <SingleSelectWithSearch
                                drpIdentity={"aCCSubHeadList"}
                                optionArray={props.receiptDetails.aCCSubHeadList}
                                value={props.receiptDetails.idGeneralProduct}
                                handleChangeTest={props.handleSelectChange}
                                searchText={props.receiptDetails.productName}
                                // classParams={props.validState?.error?.idGeneralProduct !== undefined ? "error" : ""}
                                setFilterParameters={props.setFilterParameters}
                                disabled
                            />
                        </div>

                    </div>

                    <div className="item-inner grid grid-cols-4 gap-2.5 mt-2.5 mb-3">
                        <div className="input-grp">
                            <label>Payment mode</label>
                            <SingleSelectWithSearch
                                drpIdentity={"PaymentMode"}
                                optionArray={props.receiptDetails.paymentModeList}
                                value={props.receiptDetails.idPaymentMode}
                                handleChangeTest={props.handleSelectChange}
                                searchText={props.receiptDetails.paymentMode}
                                classParams={props.validState?.error?.idPaymentMode !== undefined ? "error" : ""}
                                setFilterParameters={props.setFilterParameters}
                            />
                            {/* <SingleSelectWithSearch
                                id="paymentMode"
                                name="paymentMode"
                                value={props.receiptDetails.paymentMode}
                                handleChangeTest={(event) => props.handleSelectChange(event, "paymentMode")}
                                className={props.validState?.error?.paymentMode !== undefined ? "error" : ""} /> */}
                        </div>

                        <div className="input-grp">
                            <label>Reference no</label>
                            <TextInput
                                type="number"
                                id="refNo"
                                name="refNo"
                                value={props.receiptDetails.refNo}
                                handleChange={(event) => props.handleChange(event, "refNo")}
                                className={props.validState?.error?.refNo !== undefined ? "error" : ""} />
                        </div>

                        <div className="input-grp">
                            <label>Loan no</label>
                            <TextInput
                                type="number"
                                id="loanNo"
                                name="loanNo"
                                value={props.receiptDetails.loanNo}
                                handleChange={(event) => props.handleChange(event, "loanNo")}
                                className={props.validState?.error?.loanNo !== undefined ? "error" : ""} />
                        </div>

                        <div className="input-grp">
                            <label>Amount</label>
                            <TextInput
                                type="number"
                                id="amount"
                                name="amount"
                                value={props.receiptDetails.amount}
                                handleChange={(event) => props.handleChange(event, "amount")}
                                className={props.validState?.error?.amount !== undefined ? "error" : ""} />
                        </div>
                    </div>

                    <div className="item-inner grid grid-cols-2 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>Deposit in</label>
                            <SingleSelectWithSearch
                                drpIdentity={"depositIn"}
                                optionArray={props.receiptDetails.bankList}
                                value={props.receiptDetails.idBank}
                                handleChangeTest={props.handleSelectChange}
                                searchText={props.receiptDetails.bankName}
                                setFilterParameters={props.setFilterParameters}
                                classParams={props.validState?.error?.idBank !== undefined ? "error" : ""}
                            />
                            {/* <SingleSelectWithSearch
                                id="depositIn"
                                name="depositIn"
                                value={props.receiptDetails.depositIn}
                                handleChangeTest={(event) => props.handleSelectChange(event, "depositIn")}
                                className={props.validState?.error?.depositIn !== undefined ? "error" : ""} /> */}
                        </div>

                        <div className="input-grp">
                            <label>Remarks</label>
                            <TextInput
                                id="remarks"
                                name="remarks"
                                value={props.receiptDetails.remarks}
                                handleChange={(event) => props.handleChange(event, "remarks")} />
                        </div>
                    </div>

                    <div className="btn-grp inline-flex gap-2.5">
                        <button
                            className="update-btn btns"
                            onClick={() => props.saveItem()}
                            disabled={props.isSaving}
                        >
                            Save
                        </button>

                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    );
}